import { Suspense } from "react";
import SlideUp from "../../components/ui/SlideUp";
import verifySvg from "../../assets/images/verify.png";
import { useTranslation } from 'react-i18next';
import {features, keyResponsibilities, topList, typesOfMobileApps} from "../../constants/services/mobileDevelopment";
import TechStack from "../../components/sections/TechStack";
import Contact from "../../components/sections/Contact";
import {mobileApplicationDevelopment} from "../../constants/meta";
import Meta from "../../components/common/Helmet";
import {phoneIcon} from "../../constants/svgIcons";
import Loading from "../../components/common/Loading";

const MobileDevelopment = () => {
  const {t} = useTranslation();
  return (
    <div>
      <Meta
        title={mobileApplicationDevelopment.title}
        description={mobileApplicationDevelopment.description}
        canonical={mobileApplicationDevelopment.canonical}
        keywords={mobileApplicationDevelopment.keywords}
        ogTitle={mobileApplicationDevelopment.title}
        ogDescription={mobileApplicationDevelopment.description}
      />
      <Suspense fallback={<Loading />}>
        <div className="md:w-theme-container w-mobile-container mx-auto">
          <h2 className={`text-center md:w-[40%] mx-auto text-xl xl:text-xl md:text-2xl mt-12 uppercase mb-14`}>
            {t('mobileDevelopmentPage.mobileApplicationDevelopment')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:mt-10 mb-10 bg-yellow-3000">
            <div className="w-full rounded-3xl overflow-hidden group relative">
              <img
                src={require('../../assets/images/services/pages/mobile-application-development/1.avif')}
                alt="Professionals working on laptops"
                className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105"
              />
            </div>
            <div className="space-y-6 flex flex-col justify-center items-start">
              <h2 className="text-2xl sm:text-3xl md:text-4xl text-gray-900">
                {t('mobileDevelopmentPage.bestCompany1')} <span className="text-theme-color font-semibold">{t('mobileDevelopmentPage.mobileApplicationDevelopment')}</span> {t('mobileDevelopmentPage.bestCompany2')}
              </h2>
              <p className="text-gray-700 text-base md:text-lg">
                {t('mobileDevelopmentPage.empoweringBusiness')}
              </p>
              <div className="space-y-4">
                {topList.map((point, index) => (
                  <li
                    key={index}
                    className="flex items-start gap-3 text-gray-800"
                  >
                    <img
                      src={verifySvg}
                      alt="icon"
                      className="w-[25px] h-[25px]"
                    />
                    <span>{t(`mobileDevelopmentPage.topList.${point}`)}</span>
                  </li>
                ))}
              </div>
              <SlideUp>
                <div className="">
                  <a
                    href={`tel:+971 4 2829 613`}
                    className="w-[130px] py-3 text-base mt-8 h-10 rounded-full bg-theme-color text-white text-center flex items-center justify-center gap-x-1"
                  >{phoneIcon('#ffffff')} {t('common.callNow')}</a>
                </div>
              </SlideUp>
            </div>
          </div>
          <div className="mt-24 mb-14">
            <h2 className="text-2xl sm:text-3xl md:text-4xl text-gray-900 mb-10">🚀 {t('mobileDevelopmentPage.whatIsMobileDev')}</h2>
            <p className="text-lg mb-3">{t('mobileDevelopmentPage.whatIsMobileDevDesc')}</p>
            <div className="space-y-4">
              {typesOfMobileApps.map((point, index) => (
                <SlideUp key={index} >
                  <li className="flex items-start gap-3 text-gray-800">
                    <img
                      src={verifySvg}
                      alt="icon"
                      className="w-[25px] h-[25px]"
                    />
                    <span>{t(`mobileDevelopmentPage.typesOfMobileApps.${point}`)}</span>
                  </li>
                </SlideUp>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-yellow-3000">
            <div className="flex flex-col justify-center items-start">
              <h2 className="text-2xl sm:text-3xl md:text-4xl text-gray-900 mb-10">{t('mobileDevelopmentPage.keyResponsibilities')}</h2>
              <div className="space-y-4">
                {keyResponsibilities.map((point, index) => (
                  <SlideUp key={index} >
                    <li className="flex items-start gap-3 text-gray-800">
                      <img
                        src={verifySvg}
                        alt="icon"
                        className="w-[25px] h-[25px]"
                      />
                      <span>{t(`mobileDevelopmentPage.keyResponsibilityList.${point}`)}</span>
                    </li>
                  </SlideUp>
                ))}
              </div>
            </div>
            <SlideUp>
              <img
                src={require('../../assets/images/services/pages/mobile-application-development/2.jpg')}
                alt=""
              />
            </SlideUp>
          </div>
        </div>
        <div className="add-square-bg py-20">
          <div className="md:w-theme-container w-mobile-container mx-auto">
            <div className="mx-auto text-center mb-12">
              <h2 className="text-3xl text-gray-800 mb-4">
                {t('mobileDevelopmentPage.whatSetsUsApart1')} <span className="text-blue-600">{t('mobileDevelopmentPage.whatSetsUsApart2')}</span>
              </h2>
              <p className="text-lg">
                {t('mobileDevelopmentPage.innovationDriven')}
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mx-auto">
              {features.map((feature, index) => (
                <SlideUp key={index}>
                  <div className="bg-white text-gray-800 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
                    <div className="flex items-center justify-start gap-5">
                      <div className="text-3xl mb-4">{feature.icon}</div>
                      <h4 className="text-xl theme-font-bold mb-2">{t(`mobileDevelopmentPage.featureList.${feature.title}`)}</h4>
                    </div>
                    <p className="text-sm text-gray-600">{t(`mobileDevelopmentPage.featureList.${feature.description}`)}</p>
                  </div>
                </SlideUp>
              ))}
            </div>
          </div>
          <TechStack />
          <Contact />
        </div>
      </Suspense>
    </div>
  );
};

export default MobileDevelopment;
